import { PageLink, PageTitle } from "_metronic/layout/core";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import AnticipatedExpenditure from "./components/AnticipatedExpenditure";

const anticipatedExpenditureBreadCrumbs: Array<PageLink> = [
  {
    title: "Anticipated Expenditure",
    path: "/AnticipatedExpenditure",
    isSeparator: false,
    isActive: true,
  },
];

const AnticipatedExpenditurePage = () => {
  return (
    <CPLAnalytics pageName="Anticipated Expenditure">
      <PageTitle breadcrumbs={anticipatedExpenditureBreadCrumbs}></PageTitle>
      <AnticipatedExpenditure />
    </CPLAnalytics>
  );
};

export default AnticipatedExpenditurePage;
